import Base from './BaseWithFormatting.js';
import CompanyDetails from '../mixins/CompanyDetails.js';
import OpeningHours from '../mixins/OpeningHours.js';
import LoanAmounts from '../mixins/LoanAmounts.js';
import LoanDuration from '../mixins/LoanDuration.js';
import Broker from '../mixins/Broker.js';
import Archived from '../mixins/Archived.js';
import Website from '../mixins/Website.js';
import Trustpilot from '../mixins/Trustpilot.js';

export default class CorporateLoan extends Trustpilot(Website(Archived(Broker(LoanDuration(LoanAmounts(OpeningHours(CompanyDetails(Base)))))))) {

    get requiresCollateral() {
        return this._data.requires_collateral;
    }

    get requiresPersonalBail() {
        return this._data.requires_personal_bail;
    }

    get creditCheck() {
        return {
            repersentative: this._data.credit_check_representative,
            company: this._data.credit_check_company
        };
    }

    get takesUC() {
        return {
            repersentative: this._data.credit_check_representative == 'uc',
            company: this._data.credit_check_company == 'uc'
        };
    }

    get acceptsPaymentRemarks() {
        return {
            repersentative: this._data.accepts_payment_remarks_representative,
            company: this._data.accepts_payment_remarks_company
        };
    }

    get companyRequirements() {
        return {
            minRevenue: this._data.min_revenue,
            minAge: this._data.min_age,
        }
    }

    // TODO: TRANSLATE
    get companyRequirementsString() {
        return {
            minRevenue: this._data.min_revenue ? this.formatCurrency(this._data.min_revenue) : 0,
            minAge: this._data.min_age ? `${this._data.min_age} mån` : 0,
        }
    }
}